import { schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';
import {
  getIncompleteRequiredFieldIssues,
  getIncompleteRequiredFieldsMessage,
  IncompleteRequiredFieldPage,
} from './getIncompleteRequiredFieldIssues.ts';

const getPairedCostRouteItem = (page: IncompleteRequiredFieldPage) => {
  switch (page) {
    case 'details':
      return schPairedCostRouteItem.enum.details;
    case 'cost-approach':
      return schPairedCostRouteItem.enum['cost-approach'];
    case 'appraisify-commentary':
      return schPairedCostRouteItem.enum['appraisify-commentary'];
    case 'reconciliation':
      return schPairedCostRouteItem.enum.reconciliation;
  }
};

export const incompleteRequiredFields: AlertDefinition = (params) => {
  const {
    order,
    propertyDataEntities,
    compSequence,
    improvements,
    includeCostApproach,
    opinionOfSiteValue,
    marketConditionsV2,
    priorSalesCommentary,
    reconciliationCommentary,
    reconciliation,
    hasAivDiscrepancy = false,
    hasArvDiscrepancy = false,
    isMockOrder = false,
    reconciliationData,
  } = params;

  if (!order.isInspectifyOrder) {
    return [];
  }

  const issues = getIncompleteRequiredFieldIssues({
    order,
    propertyDataEntities,
    compSequence,
    improvements,
    includeCostApproach,
    opinionOfSiteValue,
    marketConditionsV2,
    priorSales: priorSalesCommentary,
    reconciliationCommentary,
    reconciliation,
    hasAivDiscrepancy,
    hasArvDiscrepancy,
    isMockOrder,
    reconciliationData,
  });

  if (issues.length === 0) {
    return [];
  }

  const firstIssue = issues[0]!;
  const pageMessage = getIncompleteRequiredFieldsMessage(firstIssue.page);

  return [
    {
      type: schAlertType.enum.incompleteRequiredFields,
      status: 'active',
      severity: 'error',
      orderType: ['appraisify'],
      message: pageMessage,
      propertyID: firstIssue.propertyID,
      fixingInfo: {
        tips: pageMessage,
        pairedCostRouteItem: getPairedCostRouteItem(firstIssue.page),
        fixingMethod: ['action'],
        commentAlwaysRequired: false,
        targetCellKey: firstIssue.targetCellKey,
      },
      triggers: getAlertTriggers({ fixRoute: firstIssue.page, order }),
    },
  ];
};
